var _path, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 60,
    viewBox: "0 0 71 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2133 59.5704C41.1455 59.6779 47.5199 59.5785 52.229 56.1651C56.2517 53.2485 56.6672 47.0986 56.6672 44.7367C56.6672 42.3747 56.7841 38.4023 57.4847 37.3285C58.1853 36.2546 60.054 36.1472 60.054 36.1472C60.054 36.1472 52.7769 35.0939 50.5933 40.227C49.2043 43.4939 50.1265 49.8904 47.6733 53.6479C46.9139 54.8118 45.7167 55.5844 44.4269 56.0961C41.486 57.2631 38.2133 55.1999 38.2133 52.2554V39.8823C38.2133 38.3793 38.2781 37.2291 38.797 35.7907C39.8537 32.8617 45.3377 31.8295 45.3377 31.8295C45.3377 31.8295 42.6818 30.6476 40.3536 30.8097C37.2836 31.0233 35.2811 33.3499 35.2811 33.3499C35.2811 33.3499 33.4995 31.155 30.2092 30.9084C27.6716 30.7184 25.2245 31.8295 25.2245 31.8295C25.2245 31.8295 30.6436 32.6648 31.7651 35.7907C32.2813 37.2291 32.3489 38.3787 32.3489 39.8823V52.2554C32.3489 55.2006 29.0762 57.2631 26.1352 56.0961C24.8448 55.5844 23.6482 54.8118 22.8882 53.6479C20.4357 49.8897 21.2667 43.525 19.9681 40.227C18.0771 35.4218 10.5074 36.1472 10.5074 36.1472C10.5074 36.1472 12.3762 36.2546 13.0768 37.3285C13.7774 38.4023 13.8943 42.3747 13.8943 44.7367C13.8943 47.0986 14.3098 53.2485 18.3325 56.1651C23.0415 59.5791 29.416 59.6779 32.3482 59.5704H38.2133Z",
    fill: "#214D4D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_162_8751)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M35.3514 0C35.3514 0 29.3911 6.05549 29.3911 14.9952C29.3911 23.935 35.3514 29.4135 35.3514 29.4135C35.3514 29.4135 41.1718 22.637 41.1718 14.7065C41.1718 6.77718 35.3514 0 35.3514 0Z",
    fill: "#437273"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M55.5301 6.60825C55.5301 6.60825 46.7484 7.84295 40.607 14.7742C34.4656 21.7054 35.3223 29.4135 35.3223 29.4135C35.3223 29.4135 44.4911 27.5385 49.9387 21.3898C55.3862 15.2412 55.5301 6.60825 55.5301 6.60825Z",
    fill: "#437273"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M15.0327 6.60825C15.0327 6.60825 23.8145 7.84295 29.9559 14.7742C36.0973 21.7054 35.2406 29.4135 35.2406 29.4135C35.2406 29.4135 26.0724 27.5385 20.6242 21.3898C15.176 15.2412 15.0327 6.60825 15.0327 6.60825Z",
    fill: "#437273"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_162_8751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.4786 16.6958C66.4786 16.6958 58.9982 17.7479 53.7662 23.6518C48.5341 29.5564 49.2645 36.1224 49.2645 36.1224C49.2645 36.1224 57.0747 34.525 61.7155 29.2875C66.357 24.0505 66.4786 16.6958 66.4786 16.6958Z",
    fill: "#437273"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_162_8751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99997 16.6958C3.99997 16.6958 11.4804 17.7479 16.7124 23.6518C21.9438 29.5564 21.2141 36.1224 21.2141 36.1224C21.2141 36.1224 13.4039 34.525 8.76309 29.2875C4.12157 24.0505 3.99997 16.6958 3.99997 16.6958Z",
    fill: "#437273"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_162_8751",
    x: 11.0327,
    y: 0,
    width: 48.4973,
    height: 37.4135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_162_8751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_162_8751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_162_8751",
    x: 45.2297,
    y: 16.6958,
    width: 25.2489,
    height: 27.4266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_162_8751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_162_8751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_162_8751",
    x: -0.0000305176,
    y: 16.6958,
    width: 25.2488,
    height: 27.4266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_162_8751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_162_8751",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.47c5243f0b3e95ffdc67d21ea778ee89.svg";
export { ForwardRef as ReactComponent };